import request from './request'

/**
 * 通用文件上传接口
 * @param {FormData} formData - 包含文件的FormData对象
 * @returns {Promise} 上传结果，包含文件URL等信息
 */
export function uploadFile(formData) {
  return request({
    url: '/web/file/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 上传图片（头像、身份证等）
 * @param {File} file - 图片文件对象
 * @returns {Promise} 上传结果
 */
export function uploadImage(file) {
  return uploadFile(file)
}


